export default "__VITE_ASSET__CELy5hZZ__"